import * as React from "react";
import { ITextStyles, Stack, TextField } from "@fluentui/react";
import { INumberInputProps } from "../../../../../interfaces/advancedSearch/INumberInputProps";

export const NumberFieldInput: React.FunctionComponent<INumberInputProps> = props => {
  const handleOnChange = React.useCallback((event: any, newValue?: string) => {
    props.handleValueChange(props.searchInputData?.index, newValue);
  }, []);

  const textStyles: Partial<ITextStyles> = { root: { width: "100%" } };
  return (
    <TextField
      label={props.displayName}
      type="number"
      value={props.searchInputData?.value ?? ""}
      // min={props.min !== undefined ? props.min : ""}
      // max={props.max !== undefined ? props.max : ""}
      onChange={handleOnChange}
      className="xb-sp-input"
      styles={textStyles}
    />
  );
};

export default NumberFieldInput;
